import React from 'react';

export const UserPlus = ({ width = 20, height = 20, className = '' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.50033 3.33333C6.11961 3.33333 5.00033 4.45262 5.00033 5.83333C5.00033 7.21405 6.11961 8.33333 7.50033 8.33333C8.88104 8.33333 10.0003 7.21405 10.0003 5.83333C10.0003 4.45262 8.88104 3.33333 7.50033 3.33333ZM3.33366 5.83333C3.33366 3.53215 5.19914 1.66667 7.50033 1.66667C9.80151 1.66667 11.667 3.53215 11.667 5.83333C11.667 8.13452 9.80151 10 7.50033 10C5.19914 10 3.33366 8.13452 3.33366 5.83333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83366 13.3333C5.17062 13.3333 4.53473 13.5967 4.06589 14.0656C3.59705 14.5344 3.33366 15.1703 3.33366 15.8333V17.5C3.33366 17.9602 2.96056 18.3333 2.50033 18.3333C2.04009 18.3333 1.66699 17.9602 1.66699 17.5V15.8333C1.66699 14.7283 2.10598 13.6685 2.88738 12.8871C3.66878 12.1057 4.72859 11.6667 5.83366 11.6667H9.16699C10.2721 11.6667 11.3319 12.1057 12.1133 12.8871C12.8947 13.6685 13.3337 14.7283 13.3337 15.8333V17.5C13.3337 17.9602 12.9606 18.3333 12.5003 18.3333C12.0401 18.3333 11.667 17.9602 11.667 17.5V15.8333C11.667 15.1703 11.4036 14.5344 10.9348 14.0656C10.4659 13.5967 9.83003 13.3333 9.16699 13.3333H5.83366Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8337 5.8271C16.2939 5.8271 16.667 6.20019 16.667 6.66043V8.3271H18.3337C18.7939 8.3271 19.167 8.70019 19.167 9.16043C19.167 9.62067 18.7939 9.99376 18.3337 9.99376H16.667V11.6604C16.667 12.1207 16.2939 12.4938 15.8337 12.4938C15.3734 12.4938 15.0003 12.1207 15.0003 11.6604V9.99376H13.3337C12.8734 9.99376 12.5003 9.62067 12.5003 9.16043C12.5003 8.70019 12.8734 8.3271 13.3337 8.3271H15.0003V6.66043C15.0003 6.20019 15.3734 5.8271 15.8337 5.8271Z"
      fill="currentColor"
    />
  </svg>
);
